const actionTypes = {
  GET_ADMIN_VIEWER_REQUEST: 'admin-viewer/GET_VIEWER_REQUEST',
  GET_ADMIN_VIEWER_ERROR: 'admin-viewer/GET_VIEWER_ERROR',
  GET_ADMIN_VIEWER_SUCCESS: 'admin-viewer/GET_VIEWER_SUCCESS',
};

export default actionTypes;
